import { render, staticRenderFns } from "./HomeExpertList.vue?vue&type=template&id=4ea99f28&scoped=true&"
import script from "./HomeExpertList.vue?vue&type=script&lang=js&"
export * from "./HomeExpertList.vue?vue&type=script&lang=js&"
import style0 from "./HomeExpertList.vue?vue&type=style&index=0&id=4ea99f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea99f28",
  null
  
)

export default component.exports